<span *ngFor="let structure of structureArray; let index = index">{{
  structureArray.length !== index + 1 ? structure.value + '.' : structure.value
}}</span>
